module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/core-js/library/modules/_iter-step.js
// module id = 340
// module chunks = 0